<template>
  <div ref="dg_state" class="flex items-center t-[#646A73]">
    <span class="status-icon mr-[5]" :class="status"></span>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "dg-state",

  data() {
    return {
      status: "",
    };
  },
  props: {
    value: [Number, String, Boolean],
  },
  watch: {
    value() {
      this.$nextTick(this.setValue);
    },
  },
  methods: {
    setValue() {
      let txt = this.$refs["dg_state"].innerText;

      if (txt.indexOf("失败") > -1 || txt.indexOf("未") > -1 || txt.indexOf("关") > -1) {
        this.status = "fail";
        return;
      }
      if (txt.indexOf("等") > -1 || txt.indexOf("待") > -1 || txt.indexOf("中") > -1 || txt.indexOf("占用") > -1) {
        this.status = "wait";
        return;
      }
      if (txt.indexOf("成功") > -1 || txt.indexOf("通过") > -1 || txt.indexOf("已") > -1 || txt.indexOf("开") > -1 || txt.indexOf("启") > -1 || txt.indexOf("闲置") > -1) {
        this.status = "success";
        return;
      }

      this.status = "unknown";
    },
  },
  created() {
    if (this.map) {
      if (!isNaN(Number(this.status))) {
        this.status = this.map[this.status];
      }
    }
  },
  mounted() {
    this.$nextTick(this.setValue);
  },
};
</script>
<style lang="less" scoped>
@import "~@/assets/css/var.less";
.aui-646A73 {
  color: #646a73;
}
.status-icon {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #d0d3d6;
  // box-shadow: 0 0 5px 0px red;
  // 'success','fail','wait','unknown'
  &.unknown {
    background: #d0d3d6;
    // box-shadow: 0 0 5px 0px #d0d3d6;
  }
  &.success {
    background: #52c41a;
    // box-shadow: 0 0 5px 0px #52c41a;
  }
  &.fail {
    background: #f41717;
    // box-shadow: 0 0 5px 0px #f41717;
  }
  &.wait {
    background: #f9b957;
    // box-shadow: 0 0 5px 0px #f9b957;
  }
}
</style>
 <style>.t-\[\#646A73\] {
    color: #646A73
}
.mr-\[5\] {
    margin-right: 5px
}
.flex {
    display: flex
}
.items-center {
    align-items: center
}</style>